<template>
  <v-app>
    <v-content>
      <transition>
        <router-view />
      </transition>
      <PortalTarget name="popup" />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({}),
  methods: {}
};
</script>
